import React, { useEffect } from "react";
import Routers from "./Routers";
import { darkTheme, lightTheme } from "./theme";
import { getSettings } from "../api/settings";
import { getLanding } from "../api/landing";

const App = () => {
  useEffect(() => {
    const theme = "light";
    if (theme === "light") {
      Object.keys(lightTheme).forEach((key) => {
        document.body.style.setProperty(`--${key}`, lightTheme[key]);
      });
    } else {
      Object.keys(darkTheme).forEach((key) => {
        document.body.style.setProperty(`--${key}`, darkTheme[key]);
      });
    }
  }, []);

  useEffect(() => {
    getSettings();
    getLanding();
  }, []);

  return <Routers />;
};

export default App;
